import React, { useEffect, useState } from "react";
import { navLinks, brandName, logoImage } from "../mock";

const LogoMark = () => (
  <a href="/" className="flex items-center gap-3 select-none">
    <img
      src={logoImage}
      alt="OpenPenguin logo"
      className="h-11 w-11 shrink-0 rounded-xl object-cover"
    />
    <span className="hidden text-[26px] font-serif italic font-semibold leading-none tracking-tight text-[#16263F] sm:inline">
      {brandName}
    </span>
  </a>
);

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const isHome = window.location.pathname === "/";
  const resolveHref = (href) => {
    if (href.startsWith("#")) {
      return isHome ? href : `/${href}`;
    }
    return href;
  };

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="flex items-center justify-between py-5">
          <LogoMark />

          {/* Glass pill nav */}
          <nav
            className={`hidden lg:flex items-center gap-1.5 rounded-full px-3 py-2 transition-all duration-300 ${
              scrolled
                ? "bg-white/60 shadow-[0_8px_30px_rgba(0,0,0,0.06)]"
                : "bg-slate-200/40"
            } backdrop-blur-md border border-white/50`}
          >
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={resolveHref(l.href)}
                className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-[15px] font-medium text-[#2a3f5f] transition-colors duration-200 hover:bg-white/70"
              >
                <span>{l.label}</span>
                {l.badge && (
                  <span className="rounded-full bg-[#5BA4FB] px-2 py-0.5 text-[10px] font-bold text-white shadow-[0_5px_14px_rgba(91,164,251,0.28)]">
                    {l.badge}
                  </span>
                )}
              </a>
            ))}
          </nav>

          <a
            href="https://platform.openpenguin.de"
            className="rounded-2xl bg-[#5BA4FB] px-4 py-2.5 text-[14px] font-semibold text-white shadow-[0_8px_20px_rgba(91,164,251,0.4)] transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#7AB5FC] active:translate-y-0 sm:px-6 sm:py-3 sm:text-[15px]"
          >
            Login
          </a>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
